import React,{useRef} from "react";
import { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import Section from "../components/Section";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  const [formData, setFormData] = useState(new FormData());

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!(formData.name && formData.email && formData.message)) {
      alert("Something went wrong!");
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        "portfolio_template",
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          alert(`Thanks ${formData.name}, I will shortly connect with you!`);
        },
        (error) => {
          console.log(error);
          alert("Something went wrong!");
        }
      );
    setFormData({});
  };

  return (
    <Section id="contact" title="Contact">
      <div className="row justify-content-between">
        <div className="col-md-5 order-last order-lg-first" data-aos="fade-up">
          <div className="subheading mb-3">Say, Hello</div>
          <form ref={form}>
            <div className="form-group pt-1 pb-2">
              <label htmlFor="username">Full Name</label>
              <input
                type="text"
                className="form-control"
                id="username"
                name="name"
                aria-describedby="emailHelp"
                placeholder="Enter your name"
                value={formData.name || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-group pt-2 pb-3">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                className="form-control"
                name="email"
                id="email"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                value={formData.email || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-group pb-4">
              <label htmlFor="userMessage">Message</label>
              <textarea
                className="form-control"
                id="userMessage"
                name="message"
                rows="3"
                placeholder="Enter message"
                value={formData.message || ""}
                onChange={handleChange}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </form>
        </div>
        <div className="col-md-6 mb-5 mb-lg-0" data-aos="fade-up">
          <div className="subheading mb-3">Reach out to me directly</div>
          <div className="contact-direct">
            <div className="row">
              <div className="col-sm-6">
                <div className="item">
                  <span>
                    <ImLocation />
                  </span>
                  <p>Prayagraj, Uttar Pradesh, India</p>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="item">
                  <span>
                    <FaPhoneAlt />
                  </span>
                  <p>+91 8081198814</p>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-map">
            <iframe
              src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJn9QLssk0hTkRGgTUaoU3Igo&key=AIzaSyAfIwaJqCMa9cw8u754GeIMuDwMqQYNSa8"
              frameBorder="0"
              allowFullScreen=""
              aria-hidden="false"
              title="Contact Me"
              tabIndex="0"
            ></iframe>
          </div>
        </div>
      </div>

      <p className="py-3 m-0 mt-5 text-center text-secondary">
        Built with React | Thanks to{" "}
        <a style={{ color: "black" }} href="https://github.com/sagnikghoshcr7">
          Sagnik
        </a>
      </p>
    </Section>
  );
};

export default Contact;
